import React, { useState, useEffect } from "react";
import { Card, Badge } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import axios from "axios";

const SalesChartBrand = () => {
  const [brandData, setBrandData] = useState([]);

  useEffect(() => {
    axios
      .get("./dati_dashboard.json")
      .then((res) => {
        const orarioBrandData = res.data.TP.orario_brand;
        setBrandData(prepareDataForChart(orarioBrandData));
      })
      .catch((err) => console.error(err));
  }, []);

  const prepareDataForChart = (orarioBrandData) => {
    const brandSales = {};
    orarioBrandData.forEach((item) => {
      const { descrizione, valore } = item;
      brandSales[descrizione] =
        (brandSales[descrizione] || 0) + parseFloat(valore);
    });

    return Object.entries(brandSales)
      .map(([brand, value]) => ({ brand, value }))
      .sort((a, b) => b.value - a.value);
  };

  const formatEuro = (val) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(val);

  return (
    <Card
      className="card ombra card-week card-home hover-effect border-0"
      style={{ borderRadius: "15px", padding: "1rem" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4 px-3">
        <h6
          className="text-title fw-bold mb-0"
          style={{ letterSpacing: "1px" }}
        >
          PERFORMANCE BRAND
        </h6>
        <Badge bg="dark" style={{ fontSize: "0.6rem" }}>
          TOP SALES
        </Badge>
      </div>

      <div style={{ width: "100%", height: 250 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={brandData}
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
            barSize={35} // Rende le barre più eleganti (non troppo larghe)
          >
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#f0f0f0"
            />

            <XAxis
              dataKey="brand"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#6c757d", fontSize: 10, fontWeight: 600 }}
              interval={0} // Mostra tutti i brand
              angle={-15} // Leggera inclinazione per leggibilità
              textAnchor="end"
            />

            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#adb5bd", fontSize: 10 }}
              tickFormatter={formatEuro}
            />

            <Tooltip
              cursor={{ fill: "#f8f9fa" }} // Effetto hover sulla riga
              contentStyle={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                fontSize: "12px",
              }}
              formatter={(value) => [formatEuro(value), "Totale Ordinato"]}
            />

            <Bar
              dataKey="value"
              radius={[6, 6, 0, 0]} // Arrotonda solo gli angoli superiori
            >
              {brandData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  // Applica il rosso al primo (top seller) e un grigio tech agli altri
                  fill={index === 0 ? "#b81f25" : "#4a4a4a"}
                  style={{ transition: "fill 0.3s ease" }}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default SalesChartBrand;
